import React from "react";
import { FormEnabler, ValidatedForm, MInput } from "components/forms";
import { Card, CardBody } from "design-react-kit";
import { BoxInfo } from "components/misc";
import {
  adminService,
  invalidFieldsMapper,
  networkErrorHelper,
  payloadBuilder,
} from "libs";

export class AdminSurveyFormAnswer extends ValidatedForm {
  emptyFields = { label: "" };

  ERROR_MESSAGES = {
    label: "Titolo della risposta non valido",
  };

  validation = { label: (v) => v && v.length >= 2 };

  FIELDS_GROUP = [
    [
      {
        id: "label-answer",
        field: "label",
        label: "Testo della risposta",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
  ];

  constructor(props) {
    super(props);
    this.state = {
      ...this.emptyFields,
      defaultValues: props.answerValue || { ...this.emptyFields },
      formActive: this.props.formActive,
      idQuestion: this.props.idQuestion,
      idAnswer: this.props.answerValue?.id || null,
    };
    this.onChange = this.onChange.bind(this);
  }

  saveRemote = () => {
    const payload = payloadBuilder(this.state);
    const action = this.state.idAnswer
      ? adminService.updateSurveyAnswer(payload)
      : adminService.insertSurveyAnswer({
          ...payload,
          idQuestion: this.state.idQuestion,
        });

    action
      .then(() => this.props.showList())
      .catch((errors) => {
        if (networkErrorHelper.is422(errors)) {
          const newState = invalidFieldsMapper(
            errors,
            this.state,
            Object.keys(this.validation)
          );
          this.setState({ ...newState });
        } else networkErrorHelper.notify(errors);
      });
  };

  render() {
    const { formActive, defaultValues } = this.state;
    const { formValid, code } = this.renderFields(
      this.FIELDS_GROUP,
      defaultValues,
      formActive
    );

    return (
      <Card className="card-big mt-0">
        <CardBody>
          <form>{code}</form>
          <BoxInfo className="mt-3">
            Anteprima risposta: {defaultValues.label}
          </BoxInfo>
          <div className="mt-2">
            <FormEnabler
              onSubmit={this.onSubmit}
              onCancel={this.props.showList}
              isFormActive={formActive}
              disableSave={!formValid}
            />
          </div>
        </CardBody>
      </Card>
    );
  }
}
